export const selectDefaultDocument = {
  data: () => ({
    icons: {
      crownIconSelected: 'active',
      crownIcon: 'fas fa-crown ',
    },
    itemId: 0,
  }),
  methods: {
    setAsDefault(e) {
      this.itemId = e.target.id;
    },
  },
};
